import { useTranslation } from 'react-i18next';
import ControlledCheckbox from '../../../../shared/ControlledFields/ControlledCheckbox';
import ControlledRadioGroup from '../../../../shared/ControlledFields/ControlledRadioGroup';
import { ControlledSelect } from 'components/shared/ControlledFields';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';
import { Typography, Grid } from '@mui/material';
import { IconTooltip } from 'components/shared/IconTooltip';

const MatchContent = ({
  control,
  getValues,
  selfMatchOptions,
  selfMatch,
  selfMatchRadioOptions,
  selfMatchStaticRadioOptions
}) => {
  const { t } = useTranslation('common', { keyPrefix: 'selfMatch' });

  const renderRadioGroups = (groups, options) =>
    groups.map(({ name, label }) => (
      <ControlledRadioGroup
        key={name}
        control={control}
        name={name}
        label={label}
        options={options}
        direction="row"
      />
    ));

  const SectionHeader = ({ titleKey, tooltipKey }) => (
    <Grid container alignItems="center">
      <Typography variant="inherit">{t(titleKey)}</Typography>
      <IconTooltip fontSize="small" title={t(tooltipKey)} placement="top-end" />
    </Grid>
  );

  const publishGroups = [
    { name: 'self_match_automatic_publish_own_action', label: t('typeOwn') },
    {
      name: 'self_match_automatic_publish_shared_action',
      label: t('typeShared')
    },
    {
      name: 'self_match_automatic_publish_preference1_action',
      label: t('preference1')
    },
    {
      name: 'self_match_automatic_publish_preference2_action',
      label: t('preference2')
    }
  ];

  const visibleGroups = [
    { name: 'self_match_automatic_visible_own_action', label: t('typeOwn') },
    {
      name: 'self_match_automatic_visible_shared_action',
      label: t('typeShared')
    },
    {
      name: 'self_match_automatic_visible_preference1_action',
      label: t('preference1')
    },
    {
      name: 'self_match_automatic_visible_preference2_action',
      label: t('preference2')
    }
  ];

  const flexGroups = [
    { name: 'self_match_flex_preference1_action', label: t('planUnitPref1') },
    {
      name: 'self_match_flex_deployableasflexpreference1_action',
      label: t('deployableAsFlex')
    },
    { name: 'self_match_flex_flex_action', label: t('allPlanUnits') },
    {
      name: 'self_match_flex_deployableasflex_action',
      label: t('deployableAsFlex')
    }
  ];

  return (
    <>
      <Typography variant="h3">{t('title')}</Typography>
      <ControlledCheckbox
        control={control}
        name="self_match_roster_match_connect"
        label={t('roster_match_connect')}
      />
      <MultiStepForm.Section
        fullWidth
        fullPadding={false}
        title={t('section1')}
      >
        <ControlledSelect
          control={control}
          name="self_match"
          label={t('section1')}
          options={selfMatchOptions(t)}
        />
        <ControlledCheckbox
          control={control}
          name="self_match_ignore_negative_balance"
          label={t('ignore_negative_balance')}
        />

        {getValues('self_match') !== selfMatch.NO_SELF_MATCH && (
          <>
            <SectionHeader titleKey="publish" tooltipKey="tooltipPublish" />
            {renderRadioGroups(publishGroups, selfMatchRadioOptions)}

            <SectionHeader titleKey="visible" tooltipKey="tooltipVisible" />
            {renderRadioGroups(visibleGroups, selfMatchRadioOptions)}
          </>
        )}
      </MultiStepForm.Section>

      <MultiStepForm.Section title={t('section2')}>
        <ControlledCheckbox
          control={control}
          name="self_match_flex_match_connect"
          label={t('flex_match_connect')}
        />
        {renderRadioGroups(flexGroups, selfMatchStaticRadioOptions(t))}
      </MultiStepForm.Section>
    </>
  );
};

export default MatchContent;
